/* Best Coins theme — small progressive enhancements. Everything works without JS. */
(function () {
  'use strict';

  var dataEl = document.getElementById('StoreData');
  var store = {};
  try { store = dataEl ? JSON.parse(dataEl.textContent) : {}; } catch (e) { store = {}; }

  /* ---------- Open now / closed status ---------- */
  var DAY_KEYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
  var DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  function parseRange(v) {
    if (!v || v === 'closed') return null;
    var p = v.split('-');
    if (p.length !== 2) return null;
    var toMin = function (s) { var hm = s.trim().split(':'); return parseInt(hm[0], 10) * 60 + parseInt(hm[1] || '0', 10); };
    var o = toMin(p[0]), c = toMin(p[1]);
    if (isNaN(o) || isNaN(c)) return null;
    return { open: o, close: c };
  }

  function fmt(min) {
    var h = Math.floor(min / 60), m = min % 60;
    var suffix = h >= 12 ? 'pm' : 'am';
    var h12 = h % 12 === 0 ? 12 : h % 12;
    return h12 + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + suffix;
  }

  function nowInStore() {
    var tz = store.timezone || 'America/New_York';
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    } catch (e) {
      var d = new Date();
      return { day: d.getDay(), min: d.getHours() * 60 + d.getMinutes() };
    }
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    var day = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(map.weekday);
    return { day: day, min: parseInt(map.hour, 10) * 60 + parseInt(map.minute, 10) };
  }

  function computeStatus() {
    if (!store.hours) return null;
    var now = nowInStore();
    var today = parseRange(store.hours[DAY_KEYS[now.day]]);
    if (today && now.min >= today.open && now.min < today.close) {
      return { open: true, label: 'Open now', detail: 'closes ' + fmt(today.close) };
    }
    if (today && now.min < today.open) {
      return { open: false, label: 'Closed now', detail: 'opens today at ' + fmt(today.open) };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      var r = parseRange(store.hours[DAY_KEYS[d]]);
      if (r) {
        return { open: false, label: 'Closed now', detail: 'opens ' + (i === 1 ? 'tomorrow' : DAY_NAMES[d]) + ' at ' + fmt(r.open) };
      }
    }
    return { open: false, label: 'Closed', detail: '' };
  }

  function renderStatus() {
    var s = computeStatus();
    if (!s) return;
    document.querySelectorAll('[data-store-status]').forEach(function (el) {
      el.classList.toggle('is-closed-now', !s.open);
      var label = el.querySelector('.js-status-label');
      var detail = el.querySelector('.js-status-detail');
      var dot = el.querySelector('.status-dot');
      if (dot) dot.classList.toggle('is-closed', !s.open);
      if (label) label.textContent = label.hasAttribute('data-short') ? (s.open ? 'Open' : 'Closed') : s.label;
      if (detail) detail.textContent = s.detail ? '· ' + s.detail : '';
      el.hidden = false;
    });
  }
  renderStatus();
  setInterval(renderStatus, 60000);

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.src = btn.getAttribute('data-src');
        main.removeAttribute('srcset');
        main.alt = btn.getAttribute('data-alt') || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (b) { b.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    wrap.querySelectorAll('button[data-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        v += parseInt(b.getAttribute('data-step'), 10);
        input.value = Math.max(parseInt(input.min || '0', 10), v);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---------- Variant picker ---------- */
  document.querySelectorAll('form.product-form').forEach(function (form) {
    var jsonEl = form.querySelector('[data-variants-json]');
    if (!jsonEl) return;
    var variants = JSON.parse(jsonEl.textContent);
    var select = form.querySelector('select[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var btn = form.querySelector('[data-add-button]');
    if (!select) return;
    select.addEventListener('change', function () {
      var v = variants.find(function (x) { return String(x.id) === select.value; });
      if (!v) return;
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? 'Add to cart' : 'Sold out'; }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    });
  });

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* ---------- Close mobile menu on Escape ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open][data-closeable]').forEach(function (d) { d.removeAttribute('open'); });
  });
})();
